import { Grid } from '@interstate/components/Grid';
import { Card } from '@interstate/components/Card';
import { styledComponentsFunctions } from '@makemydeal/dr-dash-ui-utils';
import styled from 'styled-components';
import { toRem } from '../utils/pixelUtils';

export type MediaContainerProps = {
    colorToken: ColorTokenProps;
};

export type ColorTokenProps = {
    colorComplete: string;
    colorNotComplete: string;
    borderBottomNotComplete: string;
    backgroundColorComplete: string;
};

export const StyledCardMediaContainerNotCompleted = styledComponentsFunctions.styledComponentWithExcludedProps(Grid, [
    'colorToken'
])<MediaContainerProps>`
    background-color: transparent;
    color: ${({ colorToken }) => colorToken.colorNotComplete};
    border-bottom: 1px solid ${({ colorToken }) => colorToken.borderBottomNotComplete};
    padding: 8px 0;
`;

export const StyledCardMediaContainerCompleted = styledComponentsFunctions.styledComponentWithExcludedProps(Grid, [
    'colorToken'
])<MediaContainerProps>`
    background-color: ${({ colorToken }) => colorToken.backgroundColorComplete};
    color: ${({ colorToken }) => colorToken.colorComplete};
    padding: 8px 0;
`;

export const StyledCard = styled(Card)`
    height: auto;
    && .card-header-content-container {
        padding: ${toRem(8)} ${toRem(16)};
    }
`;
